// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import Paper from '@/modules/common/components/Paper';
import Button from '@/modules/common/components/Button';
import Content from '@/modules/common/components/Content';
import Spinner from '@/modules/common/components/Spinner';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import Pagination from '@/modules/common/components/Pagination';
import ContentBody from '@/modules/common/components/ContentBody';
import ContentHeader from '@/modules/common/components/ContentHeader';
import ContentBodyTop from '@/modules/common/components/ContentBodyTop';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import { actionDockSetExpandFiles } from '@/modules/application/actions/dock';
import Table from './Table';
import DialogAdd from './DialogAdd';
import DialogEdit from './DialogEdit';
import ContextMenu from './ContextMenu';
import DialogDelete from './DialogDelete';
import '../../styles/TextFiles.scss';

const breadcrumbs = [
    {name: 'Файлы'},
    {name: 'Текстовые файлы'},
];

let abortController;

const TextFiles = (props) => {
    const { enqueueSnackbar } = useSnackbar();

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [openDialogAdd, setOpenDialogAdd] = useState(false);
    const [openDialogEdit, setOpenDialogEdit] = useState(false);
    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [positionContextMenu, setPositionContextMenu] = useState({left: null, top: null});

    const fetch = () => {
        abortController = new AbortController();
        setLoading(true);
        props.fetch.get(`/api/files/text/?${props.router.urlSearchParams.toString()}`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setData(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                setData(null);
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const closeContextMenu = () => {
        setPositionContextMenu({left: null, top: null});
    };

    useEffect(() => {
        props.dockSetExpandFiles(true);
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        let page = parseInt(props.router.urlSearchParams.get('page'));

        if (isNaN(page)) {
            page = 1;
        }
        // noinspection JSCheckFunctionSignatures
        props.router.urlSearchParams.set('page', page);
        fetch();
    }, [props.history.location.search]);

    /******************************************************************************************************************/

    const handleContextMenu = (file) => (event) => {
        event.preventDefault();
        setSelectedFile(file);
        setPositionContextMenu({left: event.clientX, top: event.clientY});
    };

    const handleClickEdit = () => {
        closeContextMenu();
        setOpenDialogEdit(true);
    };

    const handleClickDelete = () => {
        closeContextMenu();
        setOpenDialogDelete(true);
    };

    const handleCloseContextMenu = () => {
        closeContextMenu();
        setSelectedFile(null);
    };

    /******************************************************************************************************************/

    const handleAddOk = () => {
        setOpenDialogAdd(false);
        props.router.reload();
        enqueueSnackbar('Файл добавлен', {variant: 'success'});
    };

    const handleEditOk = () => {
        setOpenDialogEdit(false);
        setSelectedFile(null);
        props.router.reload();
        enqueueSnackbar('Файл изменен', {variant: 'success'});
    };

    const handleDeleteOk = () => {
        setOpenDialogDelete(false);
        setSelectedFile(null);
        props.router.reload();
        enqueueSnackbar('Файл удален', {variant: 'success'});
    };

    /******************************************************************************************************************/

    // noinspection JSUnresolvedVariable
    return (
        <Content id="text-files">
            <ContentHeader breadcrumbs={breadcrumbs}/>
            <ContentBody><Paper>
                {(!loading)
                    ? <>
                        {(data && data.results)
                            ? <>
                                <ContentBodyTop left={
                                    <Button onClick={() => setOpenDialogAdd(true)}>Добавить</Button>
                                }/>
                                <DialogAdd open={openDialogAdd} setOpen={setOpenDialogAdd} onOk={handleAddOk}/>
                                {(data.results.length > 0)
                                    ? <>
                                        <Table files={data.results} selectedFile={selectedFile}
                                               onContextMenu={handleContextMenu}
                                        />
                                        <ContextMenu position={positionContextMenu}
                                                     onClickEdit={handleClickEdit}
                                                     onClickDelete={handleClickDelete}
                                                     onClose={handleCloseContextMenu}
                                        />
                                        <DialogEdit selectedFile={selectedFile} setSelectedFile={setSelectedFile}
                                                    open={openDialogEdit} setOpen={setOpenDialogEdit}
                                                    onOk={handleEditOk}
                                        />
                                        <DialogDelete selectedFile={selectedFile} setSelectedFile={setSelectedFile}
                                                      open={openDialogDelete} setOpen={setOpenDialogDelete}
                                                      onOk={handleDeleteOk}
                                        />
                                        <Pagination totalPages={data.total_pages} currentPage={data.current_page}/>
                                    </>
                                    : null
                                }
                            </>
                            : <ErrorFetch onClick={() => fetch()}/>
                        }
                    </>
                    : <Spinner/>
                }
            </Paper></ContentBody>
        </Content>
    );
};

let Component = TextFiles;
Component = withRouter(Component);
Component = withFetch(Component);

export default connect(
    null,
    (dispatch) => ({
        dockSetExpandFiles: bindActionCreators(actionDockSetExpandFiles, dispatch),
    })
)(Component);
